// Import styles (immer)
import '../Scss/styles.scss';

// Swiper-Styles global laden (nicht im Modul)
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const cleanupFunctions = [];

function initializeModules() {
  const modules = [
    {
      selector: 'body',
      name: 'Scroll To Top',
      hasCleanup: false,
      loader: () => import('./modules/scrollToTop.js'),
      exportName: 'initScrollToTop',
    },
    {
      selector: '.burger-btn',
      name: 'Burger Menu',
      hasCleanup: false,
      loader: () => import('./modules/burger-menu.js'),
      exportName: 'initBurgerMenu',
    },
    {
      selector: '.markets-header',
      name: 'Mobile Header Scroll Toggle',
      hasCleanup: true,
      loader: () => import('./modules/mobileHeaderScrollToggle.js'),
      exportName: 'initMobileHeaderScrollToggle',
    },
    {
      selector: '[data-accordion]',
      name: 'Accordion',
      hasCleanup: true,
      loader: () => import('./modules/accordion.js'),
      exportName: 'initAccordions',
    },
    {
      selector: '.swiper',
      name: 'Swiper Container',
      hasCleanup: true,
      loader: () => import('./modules/swiperContainer.js'),
      exportName: 'initSwiperContainer',
    },
    {
      selector: '.number-item',
      name: 'Numbers',
      hasCleanup: false,
      loader: () => import('./modules/numbers.js'),
      exportName: 'initNumbers',
    },
    {
      selector: '.seasonal-calender',
      name: 'Seasonal Calender',
      hasCleanup: true,
      loader: () => import('./modules/seasonalCalender.js'),
      exportName: 'initSeasonalCalender',
    },
    {
      selector: '.tx-powermail form.powermail_form',
      name: 'Powermail Steps',
      hasCleanup: false,
      loader: () => import('./modules/powermailSteps.js'),
      exportName: 'initPowermailSteps',
    },
    {
      selector: '.tx-powermail form.powermail_form',
      name: 'Powermail Validation',
      hasCleanup: false,
      loader: () => import('./modules/validation.js'),
      exportName: 'initPowermailValidation',
    },
    {
      selector: '.tx-powermail form.powermail_form',
      name: 'Powermail Conditional Fields',
      hasCleanup: false,
      loader: () => import('./modules/powermailConditional.js'),
      exportName: 'initPowermailConditional',
    },
    {
      selector: '.tx-powermail form .powermail_legend-step',
      name: 'Powermail Legend Single Step Hide',
      hasCleanup: false,
      loader: () => import('./modules/powermailLegendSingleStepHide.js'),
      exportName: 'initPowermailLegendSingleStepHide',
    },
    {
      selector: '.tx-powermail input.powermail_date',
      name: 'Powermail Date Picker',
      hasCleanup: false,
      loader: () => import('./modules/powermailDatePicker.js'),
      exportName: 'initPowermailDatePicker',
    },
    {
      selector: '[data-contact-form-tabs]',
      name: 'Contact Form Tabs',
      hasCleanup: false,
      loader: () => import('./modules/contactFormTabs.js'),
      exportName: 'initContactFormTabs',
    },
    {
      selector: '.market-map',
      name: 'WeeklyMarkets',
      hasCleanup: false,
      loader: () => import('./modules/WeeklyMarkets/WeeklyMarkets.js'),
      exportName: 'initWeeklyMarkets',
    },

    {
      selector: '[data-video-card]',
      name: 'Video Card Grid',
      hasCleanup: true,
      loader: () => import('./modules/videoCardGrid.js'),
      exportName: 'initVideoCardGrid',
    },

    {
      selector: '.current-markets',
      name: 'currentMarkets',
      hasCleanup: false,
      loader: () => import('./modules/CurrentMarkets.js'),
      exportName: 'initCurrentMarkets',
    },

  ];

  modules.forEach((moduleConfig) => {
    if (!document.querySelector(moduleConfig.selector)) {
      return;
    }

    moduleConfig
      .loader()
      .then((mod) => {
        const initFn = mod[moduleConfig.exportName];
        if (typeof initFn !== 'function') {
          return;
        }

        const result = initFn();
        if (moduleConfig.hasCleanup && typeof result === 'function') {
          cleanupFunctions.push(result);
        }
      })
      .catch((error) => {
        console.error(`Error initializing ${moduleConfig.name}:`, error);
      });
  });
}

function cleanup() {
  cleanupFunctions.forEach((fn) => {
    try {
      fn();
    } catch (error) {
      console.error('Error during cleanup:', error);
    }
  });
  cleanupFunctions.length = 0;
}

document.addEventListener('DOMContentLoaded', initializeModules);
window.addEventListener('beforeunload', cleanup);

export { cleanup, initializeModules };
